import React, { Component } from "react";
import "./Welcome.scss";
import { shareFacebook, shareTwitter, shareWhatsapp } from "../Services/Sharing";

export default class Welcome extends Component {
    constructor() {
        super();
        this.state = {};
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="padding">
                    <div className="container">
                        <a href="https://www.ynet.co.il/home/0,7340,L-10415,00.html" target="_blank"><div className="logo"></div></a>
                        <div className="headline">
                            <div className="head">
                                זירת המנטורים
                            </div>
                            <div className="desc">
                                <span>מומחי ניהול, דיגיטל, תעשייה ובנקאות:</span><br />
                                הכירו את המנטורים שלנו שמלווים ומייעצים לנבחרת העסקים הקטנים
                            </div>
                        </div>
                        <div className="share">
                            <div onClick={shareWhatsapp} className="whatsapp"></div>
                            <div onClick={shareFacebook} className="facebook"></div>
                            <div onClick={shareTwitter} className="twitter"></div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx